export default __webpack_public_path__ + "static/media/history.130b89e5.PNG";